var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUncashedChecks = function SvgUncashedChecks(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 93,
    height: 93,
    fill: "none",
    viewBox: "0 0 93 93"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1B216B",
    d: "M46.383 92.766c25.616 0 46.383-20.767 46.383-46.383S71.999 0 46.383 0 0 20.766 0 46.383c0 25.616 20.766 46.383 46.383 46.383"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#B1BDFF",
    d: "M24.821 72.237h23.845v-7.336H24.821zM24.821 63.066h23.845V55.73H24.821z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M44.999 72.237h23.845v-7.336H44.999zM44.999 63.066h23.845V55.73H44.999z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#B1BDFF",
    d: "M24.821 53.896h23.845v-7.337H24.821z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#4553A9",
    stroke: "#B1BDFF",
    strokeWidth: 3.092,
    d: "M35.9 42.5a11.91 11.91 0 0 0 11.974-11.974A11.91 11.91 0 0 0 35.9 18.553a11.91 11.91 0 0 0-11.975 11.975A11.91 11.91 0 0 0 35.9 42.501Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M36.836 36.254v1.88h-1.777V36.26a6 6 0 0 1-3.326-1.678l1.354-1.666a4.25 4.25 0 0 0 3.02 1.25c.833 0 1.354-.417 1.354-1.043 0-.728-.52-1.042-1.875-1.458-1.875-.626-3.54-1.25-3.54-3.332a3.21 3.21 0 0 1 3.124-3.225v-1.974h1.776v2.083a6.45 6.45 0 0 1 2.81 1.354l-1.353 1.665a4.97 4.97 0 0 0-2.604-.937c-.833 0-1.354.312-1.354.937 0 .626.521.938 1.777 1.354 2.291.626 3.75 1.25 3.75 3.437a3.157 3.157 0 0 1-3.136 3.227"
  })));
};
export { SvgUncashedChecks as Icon };
export default __webpack_public_path__ + "static/media/1ac1c5587de8b7c592f196f2408959fb.svg";